import { Form } from 'antd';
import { PreceptorContactDetailsType } from '../../../components/PreceptorContactDetailsType';
import { useWizard } from '../../../components/wizard/useWizard';
import { useCallback, useEffect } from 'react';
import { PreceptorContactDetailsForm } from '../../../components/PreceptorContactDetailsForm';
import { usePreceptorContactDetails } from './usePreceptorContactDetails';
import { useNewApplication } from './useNewApplication';
import {
	Application,
	DraftState,
} from '../../../shared/VolunteerApplicationServiceTypes';

export const PreceptorContactDetailsStep = () => {
	const { preceptorDetails } = usePreceptorContactDetails();
	const {
		preceptorContactDetails,
		setPreceptorContactDetails,
		applicationDetails,
		setApplicationDetails,
	} = useNewApplication();
	const [form] = Form.useForm<PreceptorContactDetailsType>();
	const { setNextButtonDisabled, setCancelButtonDisabled } = useWizard();
	const values = Form.useWatch<PreceptorContactDetailsType>([], form);

	const handleFormValuesChange = useCallback(() => {
		try {
			setNextButtonDisabled(false);
			const newAppDetails = {
				...applicationDetails,
				draftState: DraftState.PRECEPTOR_CONTACT,
			} as Application;
			setApplicationDetails(newAppDetails);
		} catch (e) {
			setNextButtonDisabled(true);
		}
		setCancelButtonDisabled(false);
		// eslint-disable-next-line
	}, [setCancelButtonDisabled, setNextButtonDisabled, setApplicationDetails]);

	useEffect(() => {
		void handleFormValuesChange();
	}, [handleFormValuesChange, values]);

	useEffect(() => {
		form.setFieldsValue(preceptorContactDetails);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form]);

	useEffect(() => {
		const someOfMandatoryFieldsAreNotProvided = [
			preceptorDetails?.firstName,
			preceptorDetails?.mobile,
		].some((value) => value === null || value === undefined || !value);
		setNextButtonDisabled(someOfMandatoryFieldsAreNotProvided);
		const mandatoryPreceptorDetails = {
			preceptorName: `${preceptorDetails?.firstName || ''} ${
				preceptorDetails?.middleName || ''
			} ${preceptorDetails?.lastName || ''}`.trim(),
			preceptorMobile: preceptorDetails?.mobile,
			preceptorSrcmId: preceptorDetails?.srcmId,
			preceptorEmail: preceptorDetails?.email,
			preceptorMySrcmPartnerId: preceptorDetails?.mySrcmPartnerId,
		};
		setPreceptorContactDetails(mandatoryPreceptorDetails);
	}, [preceptorDetails, setPreceptorContactDetails, setNextButtonDisabled]);

	return (
		<PreceptorContactDetailsForm
			form={form}
			preceptorDetails={preceptorDetails}
		/>
	);
};
